import { AdminRole } from './admin.role';

export class AdminEditorRole extends AdminRole {}
